
import { createAction, props } from '@ngrx/store';

export const loadBrokerConfigData = createAction('[Data BrokerConfig API] Load Data',props<{ id: string }>());
export const loadBrokerConfigDataSuccess = createAction('[Data BrokerConfig API] Load Data Success', props<any>());
export const loadBrokerConfigDataFailure = createAction('[Data BrokerConfig API] Load Data Failure', props<any>());
